<template>
  <div class="event-completed-report-card common-card">
    <div v-if="isLoading === 1" class="spinner-loading">
      <Spinner></Spinner>
    </div>
    <div v-else>
      <div class="top-card">
        <div class="event-name body-text">
          {{eventInfo.eventName}}
        </div>
        <div class="expected-screened">
          <div class="expected">
            <div class="text value-text">Expected</div>
            <div class="value h1-text">{{reportData.expectedValue}}</div>
          </div>
          <div class="screened">
            <div class="text value-text">Screened</div>
            <div class="value h1-text">{{reportData.screened}}</div>
          </div>
        </div>
      </div>
      <div class="bottom-card">
        <div class="projected-scheduled">
          <div class="projected">
            <div class="text value-text">Projected Accuracy</div>
            <div class="value h4-text">{{ parseFloat(reportData.filled).toFixed(0) + '%'}}</div>
          </div>
          <div class="screened">
            <div class="text value-text">Scheduled</div>
            <div class="value h4-text">{{reportData.scheduled}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // import routerConstants from '@/router/constants';
  import { mapActions } from 'vuex';
  import Spinner from '@/components/commons/Spinner';

  export default {
    name: 'c-event-completed-report-card',
    components: {
      Spinner
    },
    props: {
      eventInfo: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        reportData: {},
        isLoading: 0
      };
    },
    methods: {
      getData () {
        if (this.isLoading !== 1) {
          this.isLoading = 1;
          this.actionGetEventReportChart({ eventId: this.eventInfo.id, reportType: 'COMPLETED' }).then(response => {
            this.reportData = response;
          }).finally(() => {
            this.isLoading = 2;
          })
        }
      },
      ...mapActions({
        actionGetEventReportChart: 'ACTION_GET_EVENT_REPORT_CHART'
      })
    },
    computed: {
    },
    created () {
      this.getData();
    },
    watch: {
      eventInfo: {
        handler: function (old, value) {
          this.getData();
        },
        deep: true
      }
    }
  };
</script>




// WEBPACK FOOTER //
// EventCompletedReportCard.vue?5182f538